import UsersProfileImage from "../UsersProfileImage";

const ContentCell = ({ key, cell }) => {
  if (cell.value === "user_block") {
    return (
      <td key={key} style={cell.style} className="teambook-table__user-cell">
        <UsersProfileImage size={30} user={cell.user} userImage={cell.user.avatars["30"]} header={true} style={{margin: "7px 10px"}} />
        <div className="teambook-table__user-cell__name">
          <p>{cell.user.first_name}</p>
          <p>{cell.user.last_name}</p>
        </div>
      </td>
    )
  }

  return (
    <td key={key} style={cell.style}>
      {cell.value}
    </td>
  )
}

export default ContentCell;
